import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { subscribeWorkspace, subscribeSettings, refreshWorkspace, seedWorkspace, ensureCodeProjects } from "../services/workspaceService";

const WorkspaceContext = createContext();

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspace] = useState(null);
  const [settings, setSettings] = useState({});
  const [path, setPath] = useState([]);
  const [isQuickEditorOpen, setQuickEditorOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let seeded = false;
    let projectsEnsured = false;
    const unsubWorkspace = subscribeWorkspace(async (data) => {
      const deskCount = data?.desks?.length ?? 0;
      if (!seeded && deskCount === 0) {
        seeded = true;
        try {
          await seedWorkspace();
        } catch (e) {
          console.error("[WorkspaceContext] seed failed:", e);
        }
      } else if (!projectsEnsured && deskCount > 0) {
        projectsEnsured = true;
        try {
          await ensureCodeProjects();
        } catch (e) {
          console.error("[WorkspaceContext] ensureCodeProjects failed:", e);
        }
      }
      setWorkspace(data);
      setLoading(false);
    });
    const unsubSettings = subscribeSettings((data) => {
      setSettings(data);
    });
    return () => {
      unsubWorkspace();
      unsubSettings();
    };
  }, []);

  const loadData = useCallback(async () => {
    try {
      await refreshWorkspace();
    } catch (e) {
      console.error("[WorkspaceContext] loadData failed:", e);
    }
  }, []);

  const enter = (type, id, name) => setPath((p) => [...p, { type, id, name }]);
  const back = (toIndex = -1) => {
    if (toIndex === -1) setPath((p) => p.slice(0, -1));
    else setPath((p) => p.slice(0, toIndex + 1));
  };
  const resetPath = () => setPath([]);

  return (
    <WorkspaceContext.Provider
      value={{
        workspace,
        settings,
        path,
        setPath,
        enter,
        back,
        resetPath,
        isQuickEditorOpen,
        setQuickEditorOpen,
        loading,
        loadData,
      }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const context = useContext(WorkspaceContext);
  if (!context) throw new Error("useWorkspace must be used within a WorkspaceProvider");
  return context;
}
